export default __webpack_public_path__ + "static/media/github.705e116f.png";